// Role roll-up lens (#169, rollup.A1 — Paul A §M4: reports are "a presentation
// layer over Modules 1-3"; the same facts roll up differently depending on
// who's reading). Two lenses: `met` keeps today's tag-level detail
// (pixel-identical), `gm` compresses to a handful of window figures vs target.
// No on-surface switch (Miles 2026-08-21 steer): the TopBar persona picker IS
// the switch, exactly like the overview role landings — this mapper mirrors
// the advisory defaultLensForPersona grouping. Operators read at tag level.
// Pure — no React.

import type { Persona } from '@/shared/types';

export type RollupLens = 'met' | 'gm';

export function defaultRollupLensForPersona(persona: Persona): RollupLens {
  switch (persona) {
    case 'GM':
    case 'Superintendent':
      return 'gm';
    case 'Operator':
      return 'met';
    default:
      return 'met';
  }
}
